import gql from 'graphql-tag';

const query = gql`
  query CookbookMeal($mealId: Int!) {
    cookbook {
      meal(mealId: $mealId) {
        id
        isFavorite
        name
        preparationVideoUrl
        preparationImageUrl
        tags {
          dietTypeTags {
            id
            name
            imageUrl
            mealsCount
          }
          mealTypeTags {
            id
            name
            imageUrl
            mealsCount
          }
          customTags {
            id
            name
            imageUrl
            mealsCount
            labelColor
          }
        }
        preparationTime {
          years
          months
          days
          hours
          minutes
          seconds
        }
        portions
        portionsAdjustable
        nutrition {
          singleServing {
            kcal
            protein {
              grams
              kcal
              percentage
            }
            fat {
              grams
              kcal
              percentage
            }
            carbohydrates {
              grams
              kcal
              percentage
            }
          }
          allServings {
            kcal
            protein {
              grams
              kcal
              percentage
            }
            fat {
              grams
              kcal
              percentage
            }
            carbohydrates {
              grams
              kcal
              percentage
            }
          }
        }
        dishes {
          id
          name
          recipe
          ingredients {
            key
            id
            name
            category {
              id
              name
              isSeasoning
              isOptional
            }
            measurements {
              measureId
              amount
              unit
              text
              isBaseUnit
            }
            kcal
            macro {
              protein {
                grams
              }
              fat {
                grams
              }
              carbohydrates {
                grams
              }
            }
            isReplaceable
            isReplaced
            replacements {
              id
              name
              measurements {
                amount
                unit
                text
              }
            }
            originalIngredient {
              key
              id
              name
              measurements {
                amount
                unit
                text
              }
            }
          }
        }
        recipeNote
        rating {
          availableLabels {
            name
          }
          averageRating {
            averageRating
            ratingsCount
          }
          userRating {
            rating
            labels {
              name
            }
          }
        }
      }
    }
  }
`;

export default query;
